import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { CommissionModel } from "../../domain/CommissionModel";
import { Grid } from "@material-ui/core";
import { Error } from "../common/Error";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { DatePicker } from "@ofqual/portal-components/components/DatePicker";

export const CommissionForecasted: React.FC<{
    sectionProps: SectionProps<CommissionModel>;
}> = ({ sectionProps }) => {
    const { control, errors, editable, getValues } = sectionProps;
    const readOnly: boolean | undefined = editable ? false : true;

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Controller
                    control={control}
                    name="forecastedStartDate"
                    as={
                        <DatePicker
                            label="Forecasted Start Date"
                            data-test="commission-forecastedStartDate"
                            clearable
                            returnDayBoundary="endOfDay"
                            readOnly={readOnly}
                            formatDate = "dd MMMM yyyy"
                            dataTest="forecasted-start-date"
                        />
                    }
                />
            </Grid>

            <Grid item xs={12}>
                <Controller
                    control={control}
                    name="estimatedNumberOfDaysRequired"
                    rules={{ min: 0, max: 99999.9 }}
                    as={
                        <TextField
                            type = "number"
                            variant="outlined"
                            label="Estimated number of days required"
                            data-test="commission-estimatedNumberOfDaysRequired"
                            fullWidth
                            InputProps={{
                                readOnly: readOnly,
                            }}
                        />
                    }
                />
                {errors.estimatedNumberOfDaysRequired?.type === "min" && (
                    <Error data-test="error-estimatedNumberOfDaysRequired-field-min">The estimated days must be higher than 0 days</Error>
                )}
                {errors.estimatedNumberOfDaysRequired?.type === "max" && (
                    <Error data-test="error-estimatedNumberOfDaysRequired-field-max">The estimated days must be less than 99999 days</Error>
                )}
            </Grid>

            <Grid item xs={12}>
                <Controller
                    control={control}
                    name="forecastedEndDate"
                    rules={{
                        validate: (forecastedEndDateValue) => {
                            const { forecastedStartDate } = getValues();
                            if (forecastedStartDate && forecastedEndDateValue) {
                                return forecastedEndDateValue >= forecastedStartDate || "End date should not be earlier than the start date";
                            }
                        },
                    }}
                    as={
                        <DatePicker
                            label="Forecasted End Date"
                            data-test="commission-forecastedEndDate"
                            clearable
                            returnDayBoundary="endOfDay"
                            readOnly={readOnly}
                            formatDate = "dd MMMM yyyy"
                            dataTest="forecasted-end-date"
                        />
                    }
                />
                {errors.forecastedEndDate && (
                    <Error data-test="error-forecastedEndDate">{errors.forecastedEndDate.message}</Error>
                )}
            </Grid>
        </Grid>
    );
};